import React from 'react';
import {Row, Col, Box, Button} from 'adminlte-2-react';
import Loader from '../utils/Loader';
import {TextInput} from '../utils/TextInput';
import {ReferenciaObligatorios} from '../utils/etiquetaObligatorio/ReferenciaObligatorios';
import {Alert} from '../utils/Alert';
import {PhoneV2} from '../utils/PhoneV2';
import {SelectInput} from '../utils/SelectInput';
import {documentTypeOptions, rolesByName, rolOptions} from '../utils/constants';
import {CustomBox} from '../ui/layout/CustomBox';
import {Content} from '../ui/Content';
import {useEffect} from 'react';
import {useState} from 'react';

function UsuarioEditView({
  mode,
  usuarioEdit,
  submit,
  topAlert,
  rolOption,
  setRolOption,
  nombre,
  setNombre,
  username,
  setUsername,
  password,
  setPassword,
  documentType,
  setDocumentType,
  documento,
  setDocumento,
  tel,
  setTel,
  submitAlert,
  estadoOption,
  setEstadoOption,
  history,
  token,
}) {
  const title = mode === 'create' ? 'Crear usuario ' : 'Editar usuario';

  return (
    <Content title={title} history={history}>
      <Row>
        <Col md="4" mdOffset="4">
          <CustomBox
            title="Datos"
            history={history}
            footer={
              <Button
                type="primary"
                disabled={usuarioEdit.loading}
                text={
                  <Loader loaderColor="#ffffff" isLoading={usuarioEdit.loading}>
                    Guardar cambios
                  </Loader>
                }
                pullRight={true}
                onClick={submit}
              />
            }>
            <ReferenciaObligatorios />

            {topAlert.text && (
              <Alert
                title={topAlert.title}
                type={topAlert.type}
                text={topAlert.text}
                closable={topAlert.closable}
              />
            )}

            {mode === 'create' && (
              <SelectInput
                label="Rol"
                value={rolOption}
                options={rolOptions}
                setValue={setRolOption}
                required={true}
              />
            )}

            <TextInput
              label="Nombre"
              initialValue={nombre}
              setValue={setNombre}
              required={true}
            />

            {mode === 'create' && (
              <TextInput
                label="Email"
                initialValue={username}
                setValue={setUsername}
                required={true}
              />
            )}

            {mode === 'create' && (
              <TextInput
                label="Password"
                initialValue={password}
                setValue={setPassword}
                required={true}
              />
            )}

            <SelectInput
              label="Tipo de documento"
              value={documentType}
              options={documentTypeOptions}
              setValue={setDocumentType}
              required={false}
            />

            <TextInput
              label={'Nro de documento'}
              initialValue={documento}
              setValue={setDocumento}
              required={true}
            />

            <PhoneV2
              label="Teléfono"
              value={tel}
              setValue={setTel}
              international={false}
            />

            {submitAlert.text && (
              <Alert
                title={submitAlert.title}
                type={submitAlert.type}
                text={submitAlert.text}
                closable={submitAlert.closable}
              />
            )}
          </CustomBox>
        </Col>
      </Row>
    </Content>
  );
}

export {UsuarioEditView};
